import { render } from "./ThePassDialogs.vue?vue&type=template&id=1990ec40"
import script from "./ThePassDialogs.vue?vue&type=script&lang=js"
export * from "./ThePassDialogs.vue?vue&type=script&lang=js"
script.render = render

export default script